import React from 'react'
import './Footer.css'

const Footer = () => {
    return (
        <div className="copyright">
            Copyright © 2026 ЛУКС МЕДИКУС
        </div>
    )
}

export default Footer
